import { TYPE_OF_DAMAGE } from '@/api/types';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/Form';
import InstructionHint from '@/components/ui/InstructionHint';
import RadioGroup, { RadioItem } from '@/components/ui/RadioGroup';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const TYPE_OF_DAMAGE_NAME = 'type_of_damage';
export const RadioGroupTypeOfDamage = ({
  name = 'type_of_damage',
  onChange,
}: {
  name?: string;
  onChange?: (value: string) => void;
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{i18n.t('Wskaż rodzaj zgłaszanej szkody')}</FormLabel>
          <InstructionHint
            title={i18n.t(
              'Informację o rodzaju szkody znajdziesz w piśmie, decyzji lub mailu od ubezpieczyciela.'
            )}
          />
          <FormControl>
            <RadioGroup
              {...field}
              onChange={(val) => {
                onChange && onChange(val as string);
                field.onChange(val);
              }}
              layout={'horizontal'}
              data-testid="radio-group-type-of-damage"
            >
              <RadioItem
                value={TYPE_OF_DAMAGE.PART_OC}
                label={i18n.t('Szkoda częściowa OC')}
                data-testid="radio-item-type-of-damage-part-oc"
              />
              <RadioItem
                value={TYPE_OF_DAMAGE.FULL_OC}
                label={i18n.t('Szkoda całkowita OC')}
                data-testid="radio-item-type-of-damage-full-oc"
              />
              <RadioItem
                value={TYPE_OF_DAMAGE.PART_AC}
                label={i18n.t('Szkoda częściowa AC')}
                data-testid="radio-item-type-of-damage-part-ac"
              />
              <RadioItem
                value={TYPE_OF_DAMAGE.FULL_AC}
                label={i18n.t('Szkoda całkowita AC')}
                data-testid="radio-item-type-of-damage-full-ac"
              />
            </RadioGroup>
          </FormControl>
        </FormItem>
      )}
    />
  );
};
